// import React from 'react'

import { Card } from 'react-bootstrap'

export default Card
